import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCollaboration, fetchCollaborations } from "services/api/collaboration-legacy";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { CollaborationChatRoom } from "types/chat";
import { CollaborationLegacy, CollaborationLegacySlice } from "types/collaboration-legacy";
import { generateUniqueKey, getErrorMessage, isFresh } from "utils/helpers";

export const fetchLegacyCollaborationsListThunk = createAsyncThunk<{ count: number, items: CollaborationLegacy[], filters: { page: number, [key: string]: any }, filterId: string }, { filters: { page: number, [key: string]: any }, force?: boolean }, { rejectValue: string }>(
    'legacyCollaborations/list',
    async ({ filters, force }, { getState, rejectWithValue }) => {
        try {
            const { page } = filters;
            const STALE_TIME = apiConfig.FETCH_COLLABORATIONS.staleTime;

            const state = getState() as { auth: AuthState, legacyCollaborations: CollaborationLegacySlice }
            const filterId = generateUniqueKey(filters, ['page']);

            if (page === 1 && !force && isFresh(state.legacyCollaborations?.filtered_lists?.[filterId]?.last_fetched_at, STALE_TIME)) {
                return rejectWithValue(ERROR.CACHED);
            }

            const hubId = state.auth.selectedHubId;
            if (!hubId) throw new Error("No hub selected!");

            const { count, items } = await fetchCollaborations(hubId, { ...filters });

            return { count, items, filters, filterId }


        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collaboration!"));
        }
    }
)

export const fetchLegacyCollaborationThunk = createAsyncThunk<{campaignId: string, collaborationId: string, collaboration: CollaborationLegacy, chat: CollaborationChatRoom | null, cache?: boolean}, {campaignId: string, collaborationId: string, force?: boolean}, {rejectValue: string}>(
       'legacyCollaboration/fetch',
       async ({campaignId, collaborationId, force}, {rejectWithValue, getState}) => {
        try {
            const STALE_TIME = apiConfig.FETCH_COLLABORATION.staleTime;

            const state = getState() as { auth: AuthState, legacyCollaborations: CollaborationLegacySlice }

            const cachedData = state.legacyCollaborations?.items?.[campaignId]?.[collaborationId]

            if(!force && isFresh(cachedData?.last_fetched_at, STALE_TIME)){
                return {campaignId, collaborationId, collaboration: cachedData.collaboration, cache: true, chat: cachedData.chat}
            }

            const hubId = state.auth.selectedHubId;
            if (!hubId) throw new Error("No hub selected!");

            const {collaboration: collabData, chat} = await fetchCollaboration(hubId, campaignId, collaborationId);

            return {campaignId, collaborationId, collaboration: collabData, chat};


        } catch (error) {
            return rejectWithValue(getErrorMessage(error, "Failed to fetch collab!"));
        }
       }   
)